var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { DropWrapper, DropSection } from "./components";
import { Button } from "../../button/index";
import { DateRangePicker } from "../../form/date.range/index";
import { FormGroup, SelectAdv } from "../../..";
import { ServiceTypes, OrderTypes } from "@lib/common";
let ProtableExport = class ProtableExport extends React.Component {
    openCustomExportModal = () => { };
    supportCustomReport;
    constructor(props) {
        super(props);
        const { openCustomExportModal, exportSettings } = this.props;
        if (openCustomExportModal) {
            this.openCustomExportModal = openCustomExportModal;
        }
        this.supportCustomReport = !!openCustomExportModal && !!exportSettings;
        this.state = {
            start: this.daysAgoMills(7),
            end: Date.now(),
            orderType: OrderTypes.All,
            serviceType: ServiceTypes.All,
            appModal: false,
            customReport: false,
        };
    }
    daysAgoMills = (days) => {
        return Date.now() - 1000 * 60 * 60 * 24 * days;
    };
    setRange = (start) => {
        this.setState({ start, end: Date.now() });
    };
    exportData = () => {
        if (this.supportCustomReport && this.state.customReport)
            return this.exportCustomData();
        else
            return this.exportStandardData();
    };
    exportCustomData = () => {
        const { exportUrl, exportSettings } = this.props;
        const { orderType, serviceType } = this.state;
        const { columns } = exportSettings;
        const activeColumns = [];
        Object.values(columns).forEach((c) => {
            if (c.active) {
                activeColumns.push(c.name);
            }
        });
        const { start, end } = this.state;
        window.open(`${exportUrl}&start=${start}&end=${end}&columns=${activeColumns}&order_type=${orderType}&service_type=${serviceType}`);
    };
    exportStandardData = () => {
        const { exportUrl } = this.props;
        const { start, end } = this.state;
        window.open(`${exportUrl}&start=${start}&end=${end}`);
    };
    handleCustomLayoutToggle = () => {
        this.setState({ customReport: !this.state.customReport });
    };
    render() {
        if (!this.state)
            return;
        const { store, region } = this.props;
        const s = store.s;
        const { orderType, serviceType, customReport } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement(DropWrapper, { active: s.dropdown === "export" },
                React.createElement(DropSection, null,
                    React.createElement("h4", { className: "" }, "CSV Data Export"),
                    React.createElement("p", { className: "m-t-2 lhp max700" }, "You can export all your data into CSV format which can be used by Microsoft Excel and other softwares. Exporting may take a long time if you have a large amount of data. It can also place a large load on our servers so please do not abuse this feature.")),
                React.createElement(DropSection, null,
                    React.createElement("p", { className: "big font-semi-bold m-b-3" }, "Export Date Range"),
                    React.createElement(DateRangePicker, { formats: region.formats, timezone: region.timezone, start: this.state.start, end: this.state.end, onSelect: (type, timestamp) => {
                            if (type === "start")
                                this.setState({ start: timestamp });
                            else if (type === "end")
                                this.setState({ end: timestamp });
                        } }),
                    React.createElement("div", { className: "m-t-3" },
                        React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(7)), className: "m-r-2" }, "Last 7 Days"),
                        React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(30)), className: "m-r-2" }, "Last 30 Days"),
                        React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(90)), className: "m-r-2" }, "Last 90 Days"),
                        React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(1000)) }, "All Time"))),
                this.supportCustomReport && customReport && (React.createElement(React.Fragment, null,
                    React.createElement(DropSection, null,
                        React.createElement("p", { className: "big font-semi-bold m-b-3" }, "Order Type"),
                        React.createElement(FormGroup, { help: React.createElement("span", null, "Choose which type of order to export") },
                            React.createElement("div", { style: { width: "400px" } },
                                React.createElement(SelectAdv, { type: "single", options: [
                                        {
                                            value: OrderTypes.All,
                                            label: "All",
                                        },
                                        {
                                            value: OrderTypes.Now,
                                            label: "Now",
                                        },
                                        {
                                            value: OrderTypes.Later,
                                            label: "Laters",
                                        },
                                    ], value: orderType.toString(), onChange: (option) => {
                                        this.setState({
                                            orderType: option,
                                        });
                                    } })))),
                    React.createElement(DropSection, null,
                        React.createElement("p", { className: "big font-semi-bold m-b-3" }, "Service Type"),
                        React.createElement(FormGroup, { help: React.createElement("span", null, "Choose which type of Order Service to export") },
                            React.createElement("div", { style: { width: "400px" } },
                                React.createElement(SelectAdv, { type: "single", options: [
                                        {
                                            value: ServiceTypes.All,
                                            label: "All",
                                        },
                                        {
                                            value: ServiceTypes.Pickup,
                                            label: "Pickup",
                                        },
                                        {
                                            value: ServiceTypes.Delivery,
                                            label: "Delivery",
                                        },
                                        {
                                            value: ServiceTypes.DineIn,
                                            label: "Dine In",
                                        },
                                    ], value: serviceType.toString(), onChange: (option) => {
                                        this.setState({
                                            serviceType: option,
                                        });
                                    } })))),
                    React.createElement(DropSection, null,
                        React.createElement("p", { className: "big font-semi-bold m-b-3" }, "Report Columns"),
                        React.createElement(Button, { color: "primary-inverse", size: "xs", onClick: this.openCustomExportModal }, "Edit Report Columns")))),
                React.createElement(DropSection, null,
                    React.createElement(Button, { color: "primary", size: "xs", onClick: this.exportData, className: "m-r-2" }, "Export Data"),
                    this.supportCustomReport && (React.createElement(Button, { color: "primary-inverse", size: "xs", onClick: this.handleCustomLayoutToggle },
                        customReport ? "Standard" : "Custom",
                        " Report"))))));
    }
};
ProtableExport = __decorate([
    observer
], ProtableExport);
export { ProtableExport };
//# sourceMappingURL=export.js.map